import AdminUsersContainer from './users-container';

export default AdminUsersContainer;